// import React, { useState, useEffect } from "react";
// import { Formik, Form, Field, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import Swal from "sweetalert2";
// import Logo from "../../assets/images/Logo.png";
// import { useNavigate } from "react-router-dom";
// import { Influencerlogin, login } from "../api/api";
// import OneSignal from "react-onesignal";
// import "../InfluencerLoginPage/InfluencerLoginPage.css";
// import bgImage from "../../assets/images/brown-background.jpg";
// import { v4 as uuidv4 } from "uuid";
// import aboutbanners from "../../assets/images/about-head-banner.jpg";
// import { FaChevronRight } from "react-icons/fa";

// const InfluencerLoginPage = () => {
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(false);
//   const [deviceToken, setDeviceToken] = useState("");
//   const [jwtsToken, setjwtsToken] = useState("");
//   useEffect(() => {
//     const influencerData = localStorage.getItem("influencerData");
//     if (influencerData) {
//       navigate("/", { replace: true });
//       // navigate("/");
//     }
//   }, [navigate]);

//   useEffect(() => {
//     const jwtToken = localStorage.getItem("jwtTokeninfluencer");
//     console.log("123456_jwttokenget", jwtToken);
//     if (!jwtToken || jwtToken === "null" || jwtToken === "undefined") {
//       const generatedToken = uuidv4().replace(/-/g, "").substring(0, 32);
//       console.log("Generated Token:", generatedToken);
//       setjwtsToken(generatedToken);
//       localStorage.setItem("jwtTokeninfluencer", generatedToken);
//     } else {
//       console.log("jwt_notget");
//       setjwtsToken(jwtToken);
//     }
//   }, []);

//   const validationSchema = Yup.object({
//     email: Yup.string()
//       .email("Invalid email format")
//       .required("Email is required"),
//     password: Yup.string()
//       .min(6, "Password must be at least 6 characters")
//       .required("Password is required"),
//   });

//   const showAlert = (message, callback) => {
//     Swal.fire({
//       title: "",
//       text: message,
//       icon: "success",
//       confirmButtonText: "OK",
//     }).then(() => {
//       if (callback) callback();
//     });
//   };
//   const showErrorAlert = (message, callback) => {
//     Swal.fire({
//       title: "",
//       text: message,
//       icon: "error",
//       confirmButtonText: "OK",
//     }).then(() => {
//       if (callback) callback();
//     });
//   };

//   const handleSubmit = async (values) => {
//     console.log("login_value", values);
//     try {
//       setIsLoading(true);
//       const response = await Influencerlogin(values);
//       console.log("login_Reaponse", response);
//       if (response?.success) {
//         localStorage.setItem("influencerData", JSON.stringify(response?.data));
//         showAlert(response?.message, () =>
//           navigate("/InfluencerPage", { replace: true })
//         );
//       } else {
//         showErrorAlert(response?.message);
//       }
//     } catch (error) {
//       console.error("Login error:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="mainallsection">
//       <div
//         className="bannersec"
//         style={{
//           backgroundImage: `url(${aboutbanners})`,
//         }}
//       >
//         <h4>InfluencerLoginPage</h4>
//         <p>
//           Home{" "}
//           <span>
//             <FaChevronRight />
//           </span>{" "}
//           InfluencerLoginPage
//         </p>
//       </div>
//       <div
//         className="Inlogin-box"
//         style={{
//           backgroundImage: `url(${bgImage})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//         }}
//       >
//         <Formik
//           initialValues={{
//             email: "",
//             password: "",
//             jwt: jwtsToken,
//           }}
//           validationSchema={validationSchema}
//           onSubmit={handleSubmit}
//           enableReinitialize={true}
//         >
//           {({ isSubmitting }) => (
//             <Form className="Inlogin-form">
//               <img src={Logo} alt="Logo" className="Inlogin-logo" />
//               <h1 className="Inlogin-heading">Affiliate Access</h1>
//               <div className="Inloginform-group">
//                 <label>Email</label>
//                 <Field type="email" name="email" className="Inform-input" />
//                 <ErrorMessage
//                   name="email"
//                   component="div"
//                   className="Inerror-message"
//                 />
//               </div>
//               <div className="Inloginform-group">
//                 <label>Password</label>
//                 <Field type="password" name="password" className="Inform-input" />
//                 <ErrorMessage
//                   name="password"
//                   component="div"
//                   className="Inerror-message"
//                 />
//               </div>
//               <div className="ResetPasswordDiv">
//                 <p className="ClickhereText">Forgot Password / Reset Password</p>
//                 <p
//                   className="fotgotText"
//                   onClick={() => navigate("/InfluencerResetPasswordPage")}
//                 >
//                   Click Here!
//                 </p>
//               </div>
//               <button
//                 type="submit"
//                 className="Inlogin-button"
//                 disabled={isSubmitting || isLoading}
//               >
//                 {isLoading ? "Logging in..." : "Login"}
//               </button>
//             </Form>
//           )}
//         </Formik>
//       </div>
//     </div>
//   );
// };

// export default InfluencerLoginPage;

import React, { useState, useEffect, useCallback } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import Logo from "../../assets/images/Logo.png";
import { useNavigate } from "react-router-dom";
import { Influencerlogin, login } from "../api/api";
import OneSignal from "react-onesignal";
import "../InfluencerLoginPage/InfluencerLoginPage.css";
import bgImage from "../../assets/images/brown-background.jpg";
import { v4 as uuidv4 } from "uuid";
import aboutbanners from "../../assets/images/about-head-banner.jpg";
import { FaChevronRight } from "react-icons/fa";

const InfluencerLoginPage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [deviceToken, setDeviceToken] = useState("");
  const [jwtsToken, setjwtsToken] = useState("");
  // useEffect(() => {
  //   const storedInfluencer = localStorage.getItem("influencerData");
  //   if (storedInfluencer) {
  //     navigate("/InfluencerPage", { replace: true });
  //     setPageLoading(false);
  //   } else {
  //     navigate("/InfluencerLoginPage", { replace: true });
  //     setPageLoading(false);
  //   }
  // }, [navigate]);
  useEffect(() => {
    const influencerData = localStorage.getItem("influencerData");
    if (influencerData) {
      setPageLoading(false);
      console.log("value_is_here", influencerData);
      navigate("/InfluencerPage", { replace: true });
    } else {
      setPageLoading(false);
      console.log("value_is_nothere", influencerData);
      navigate("/AffiliateAccess", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const jwtToken = localStorage.getItem("jwtTokeninfluencer");
    console.log("123456_jwttokenget", jwtToken);
    if (!jwtToken || jwtToken === "null" || jwtToken === "undefined") {
      const generatedToken = uuidv4().replace(/-/g, "").substring(0, 32);
      console.log("Generated Token:", generatedToken);
      setjwtsToken(generatedToken);
      localStorage.setItem("jwtTokeninfluencer", generatedToken);
    } else {
      console.log("jwt_notget");
      setjwtsToken(jwtToken);
    }
  }, []);

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
  });

  const showAlert = (message, callback) => {
    Swal.fire({
      title: "",
      text: message,
      icon: "success",
      confirmButtonText: "OK",
    }).then(() => {
      if (callback) callback();
    });
  };
  const showErrorAlert = (message, callback) => {
    Swal.fire({
      title: "",
      text: message,
      icon: "error",
      confirmButtonText: "OK",
    }).then(() => {
      if (callback) callback();
    });
  };

  const handleSubmit = async (values) => {
    console.log("login_value", values);
    try {
      setIsLoading(true);
      const response = await Influencerlogin(values);
      console.log("login_Reaponse", response);
      if (response?.success) {
        localStorage.setItem("influencerData", JSON.stringify(response?.data));
        showAlert(response?.message, () =>
          navigate("/InfluencerPage", { replace: true })
        );
      } else {
        showErrorAlert(response?.message);
      }
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (pageLoading) {
    return (
      <div className="loadingdiv">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="mainallsection">
      <div
        className="bannersec"
        style={{
          backgroundImage: `url(${aboutbanners})`,
        }}
      >
        <h4>Affiliate Access</h4>
        <p>
          Home{" "}
          <span>
            <FaChevronRight />
          </span>{" "}
          Affiliate Access
        </p>
      </div>
      <div
        className="Inlogin-box"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Formik
          initialValues={{
            email: "",
            password: "",
            jwt: jwtsToken,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ isSubmitting }) => (
            <Form className="Inlogin-form">
              <img src={Logo} alt="Logo" className="Inlogin-logo" />
              <h1 className="Inlogin-heading">Affiliate Access</h1>
              <div className="Inloginform-group">
                <label>Email</label>
                <Field type="email" name="email" className="Inform-input" />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="Inerror-message"
                />
              </div>
              <div className="Inloginform-group">
                <label>Password</label>
                <Field
                  type="password"
                  name="password"
                  className="Inform-input"
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="Inerror-message"
                />
              </div>
              <div className="ResetPasswordDiv">
                <p className="ClickhereText">
                  Forgot Password / Reset Password
                </p>
                <p
                  className="fotgotText"
                  onClick={() => navigate("/InfluencerResetPasswordPage")}
                >
                  Click Here!
                </p>
              </div>
              <button
                type="submit"
                className="Inlogin-button"
                disabled={isSubmitting || isLoading}
              >
                {isLoading ? "Logging in..." : "Login"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default InfluencerLoginPage;
